import { render, staticRenderFns } from "./proficiencies.vue?vue&type=template&id=351e5934&scoped=true&"
import script from "./proficiencies.vue?vue&type=script&lang=js&"
export * from "./proficiencies.vue?vue&type=script&lang=js&"
import style0 from "./proficiencies.vue?vue&type=style&index=0&id=351e5934&lang=scss&scoped=true&"
import style1 from "./proficiencies.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351e5934",
  null
  
)

export default component.exports